<template>
    <div>
      <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
        <template slot="left">
          <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
            <h1><v-icon large>mdi-basket</v-icon>{{$t('order.resolution')}}</h1>
          </v-toolbar-title>
        </template>
      </Toolbar>
      <OrderResolutionForm ref="createForm" :values="item" :errors="violations" />
      <Loading :visible="isLoading" />
    </div>
  </template>
  
  <script>
  import { mapActions } from 'vuex';
  import { createHelpers } from 'vuex-map-fields';
  import OrderResolutionForm from '../../components/orderresolution/Form';
  import Loading from '../../components/Loading';
  import Toolbar from '../../components/Toolbar';
  import CreateMixin from '../../mixins/CreateMixin';
  
  const servicePrefix = 'OrderResolution';
  
  const { mapFields } = createHelpers({
    getterType: 'orderresolution/getField',
    mutationType: 'orderresolution/updateField'
  });
  
  export default {
    name: 'OrderResolutionCreate',
    servicePrefix,
    mixins: [CreateMixin],
    components: {
      Loading,
      Toolbar,
      OrderResolutionForm
    },
    data() {
      return {
        item: {}
      };
    },
    computed: {
      ...mapFields(['error', 'isLoading', 'created', 'violations'])
    },
    methods: {
      ...mapActions('orderresolution', ['create', 'reset'])
    }
  };
  </script>
  